module.exports = __webpack_public_path__ + "img/9788958073642.8f402d58.jpg";